<template>
    <v-dialog persistent v-model="dialog" width="30%">
        <v-card fluid>
            <v-card-title>Get park code</v-card-title>
            <v-divider  class="ml-2 mr-2 mb-2"></v-divider>
            <v-card-text> 
                <v-row no-gutters dense>
                    <v-col cols="6" class="py-2 pl-2">
                        <date_picker label="Booking date from"                                 
                                     :date="hsabBookingDateFrom"
                                     :startDate="hsabBookingDateFrom"
                                     field="hsabBookingDateFrom" 
                                     hint="Only enter a date if applicable" 
                                     icon="mdi-calendar-month-outline"
                                     :manual="true" 
                                     @updateData="updateData"/> 
                    </v-col>
                    <v-col cols="6" class="py-2 pl-2">
                        <date_picker label="Booking date until"                                 
                                     :date="hsabBookingDateUntil"
                                     :startDate="hsabBookingDateFrom"
                                     field="hsabBookingDateUntil" 
                                     hint="Only enter a date if applicable" 
                                     icon="mdi-calendar-month-outline"
                                     :manual="true" 
                                     @updateData="updateData"/> 
                    </v-col>
                </v-row>                
                <v-row no-gutters dense class="">
                    <v-col cols="5" offset="1" class="flex-row">
                        <v-text-field v-model="product_id" label="Product id"></v-text-field>
                    </v-col>
                    <v-col cols="6" class="flex-row pl-3">
                        <v-btn small @click="getParcCode" :loading="loading" color="success">
                            check
                        </v-btn>
                        <v-text-field v-model="parccode" label="Park code" class="pl-2"></v-text-field>
                    </v-col>                        
                </v-row>
            </v-card-text>
            <v-divider  class="ml-2 mr-2"></v-divider>
            <v-card-actions >
                <v-row cols="12" dense class="mb-2">
                    <v-col cols="7" class="pr-3 flex-row-top">
                    <v-icon v-if="error!==''" color="red" class="mr-2">mdi-alert-circle-outline</v-icon><div class="error">{{ error }}</div>
                </v-col>
                    <v-spacer></v-spacer>    
                <v-btn @click="cancelDialog" color="primary" class="mt-2 mr-2">
                    cancel
                </v-btn>                  
                <v-btn @click="closeDialog" color="success" class="mt-2" :disabled="parccode===''">
                    use code
                </v-btn>     

                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    
    import date_picker from '@/components/ui/date_picker.vue';

    export default {
        components: {
            date_picker
        },        
        data() {
            return {
                product_id: '',
                hsabBookingDateFrom: null,
                hsabBookingDateUntil: null,
                parccode: '',
                error: '',
                dialog: false,
                loading: false,
                field: ''
            }
        },    
        methods: {
            open(field) {
                this.dialog = true   
                this.resetValues()   
                this.field = field          
            },                    
            closeDialog() {
                this.dialog = false;
                this.$emit('updateData', {field: this.field, value: this.parccode});
            },    
            cancelDialog() {
                this.dialog = false;
            },                    
            updateData(data){
                this[data.field] = data.value;
            },            
            resetValues () {
                this.product_id = ''
                this.error = '',
                this.parccode = '',
                this.field = '',
                this.hsabBookingDateFrom = null
                this.hsabBookingDateUntil = null
            },    
            validateValues(){
                this.error=''
                if(this.product_id==='') this.error='Product id is mandatory'
                if(this.hsabBookingDateFrom===''||this.hsabBookingDateFrom===null) this.error='Date from is mandatory'
                if(this.hsabBookingDateUntil===''||this.hsabBookingDateUntil===null) this.error='Date until is mandatory'                
                if(this.error!=='') return false 
                else return true
            }, 
            getParcCode(){

                if (!this.validateValues()) return

                this.loading=true
                this.$axios
                    .post("ares/json/ares/task/pp/getParkCodev2.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getparccode"
                        }, 
                        getparccode: {
                            fromdate: this.hsabBookingDateFrom,
                            untildate: this.hsabBookingDateUntil,
                            product_id: this.product_id
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            this.error = res.data.error.message
                        } else {
                            this.parccode = res.data.getparccode.parkcode                       
                        }
                        this.loading=false
                    })

            }
        }
    }
</script>

<style scoped>
.flex-row-top{
    display: flex;
    flex-direction: row;
    align-items:flex-start;
}
.flex-row{
    display: flex;
    flex-direction: row;
    align-items:center;
}

.text-color{
    color: black !important;
}
.error{
    background-color: transparent !important;
    color: red !important;
}
</style>